import { render, staticRenderFns } from "./specialPrice.vue?vue&type=template&id=20414c49&scoped=true&"
import script from "./specialPrice.vue?vue&type=script&lang=js&"
export * from "./specialPrice.vue?vue&type=script&lang=js&"
import style0 from "./specialPrice.vue?vue&type=style&index=0&id=20414c49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20414c49",
  null
  
)

export default component.exports